import { graphql } from 'react-relay';

export const gqlUpdateClosetSection = graphql`
  mutation updateClosetSectionMutation($poshmarkUserId: String!, $id: String!, $name: String!) {
    superposherUpdateClosetSection(poshmarkUserId: $poshmarkUserId, id: $id, name: $name) {
      success
    }
  }
`;
